import { Stack } from "@mui/material";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardDetailRow } from "web_myplann/Dashboard/Components/DashboardDetailRow";
import { DashboardDetailSkeleton } from "web_myplann/Dashboard/Components/DashboardDetailSkeleton";
import type { DashboardType } from "web_myplann/Dashboard/Components/DashboardTitleCard";
import { useDashboardDetailData } from "web_myplann/Dashboard/Hooks/useDashboardDetailData";
import { useDashboardDetailRows } from "web_myplann/Dashboard/Hooks/useDashboardDetailRows";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EmptyListSkeleton } from "web_myplann/Shared/Components/EmptyListSkeleton";

type Props = {
	dashboard: DashboardType;
};

export const DashboardDetailV2Content: FC<Props> = ({ dashboard }) => {
	const { t } = useResource();
	const navigate = useNavigate();

	const { portfolios, properties, reporting, isLoading } =
		useDashboardDetailData(dashboard.overviewType);

	const { rows } = useDashboardDetailRows(
		portfolios?.data,
		properties?.data,
		reporting?.data,
	);

	return isLoading ? (
		<DashboardDetailSkeleton rowsPerCard={4} />
	) : rows.length === 0 ? (
		<Stack flex={1} pt={0.8} pb={2}>
			<EmptyListSkeleton
				label={t(Resources.Dashboard.EmptyList.label)}
				description={t(Resources.Dashboard.EmptyList.description)}
				height="100%"
				flex={1}
				skeletonSize="lg"
			/>
		</Stack>
	) : (
		<Stack flex={1} pt={0.8} pb={2} gap={0.8}>
			<Stack bgcolor="background.paper">
				{rows.map((row, index) => (
					<DashboardDetailRow
						key={row.id}
						row={row}
						isLast={index === rows.length - 1}
						onClick={() => navigate(row.navigateTo)}
					/>
				))}
			</Stack>
		</Stack>
	);
};
